import { useQuery } from "@tanstack/react-query";
import { isInDebugMode } from "../helpers";
import { postSearchTermFilter } from "../requests/shared/postSearchTerm/postSearchTermFilter";
import { postSearchTermMapper } from "../requests/shared/postSearchTerm/postSearchTermMapper";
import { postSearchTerm } from "../requests/shared/postSearchTerm/postSearchTermRequest";

export const useSearchQuery = (searchTerm: string, currentLanguage: string, siteId: string) => {
  return useQuery({
    queryKey: ["search", searchTerm],
    queryFn: async () => {
      if (searchTerm === "") {
        if (isInDebugMode()) {
          console.log("search string is empty");
        }

        return Promise.resolve(null);
      }

      const responseData = await postSearchTerm(searchTerm, currentLanguage, siteId);

      if (isInDebugMode()) {
        console.log("responseData: ", responseData);
      }

      const filteredData = postSearchTermFilter(responseData, 175);
      const mappedData = postSearchTermMapper(filteredData, searchTerm);

      return mappedData;
    },
    enabled: true,
    retry: false,
    staleTime: Infinity,
  });
};
